import { useT } from '../../hooks/useTranslation'
import { useDashboardStore } from '../../store/dashboardStore'

// Футер приложения (Волна 0.3, 2026-08-31): «Это не финансовый совет · 18+»
// и ссылки на Условия / Конфиденциальность (открывают LegalModal).
// Тонкая серая строка в конце каждой вкладки (в scroll-контенте, ненавязчива).
export default function LegalFooter() {
  const t = useT()
  const setActiveModal = useDashboardStore(s => s.setActiveModal)

  const linkStyle = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '2px 0',
    fontSize: 11.5,
    fontWeight: 600,
    color: '#6E6E73',
    WebkitTapHighlightColor: 'transparent',
  }

  return (
    <div style={{ padding: '18px 4px 6px', textAlign: 'center' }}>
      <div style={{ fontSize: 11, color: '#4A4A4D', lineHeight: 1.6 }}>
        {t.legalFooter}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 4 }}>
        <button onClick={() => setActiveModal('legal')} style={linkStyle}>{t.legalTerms}</button>
        <span style={{ color: '#3A3A3C' }}>·</span>
        <button onClick={() => setActiveModal('legal')} style={linkStyle}>{t.legalPrivacy}</button>
      </div>
    </div>
  )
}
